import { useEffect } from 'react'

window.nachnamen = window.nachnamen || {}

export const LoadGDETop3 = () => {
  useEffect(() => {
    if (window.nachnamen.verzeichnis) return
    console.log('----------------------LOAD TOP3')
    fetch('https://interaktiv.tagesanzeiger.ch/2025/nachnamen/gemeinden.json?a='+Math.random())
      .then((d) => d.json())
      .then((d) => {
       
        window.nachnamen.gdetop3 = d
        const event = new Event('top3_loaded')
        window.dispatchEvent(event)
      })
  }, [])
  return null
}
